// extracted by mini-css-extract-plugin
export default {"collapse":"FacetsModule_collapse__+6j89"};